export enum Direction {
    RTL = "RTL",
    LTR = "LTR",
}
